import React from 'react';
import styled from 'styled-components';

const ProductionRequestIcon = ({ width = 25, height = 24, color = '#00a4e3' }) => {
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          id="Vector"
          d="M9.5 17H15.5M9.5 14H15.5M13.5004 3.00087C13.4048 3 13.2974 3 13.1747 3H8.7002C7.58009 3 7.01962 3 6.5918 3.21799C6.21547 3.40973 5.90973 3.71547 5.71799 4.0918C5.5 4.51962 5.5 5.08009 5.5 6.2002V17.8002C5.5 18.9203 5.5 19.4801 5.71799 19.9079C5.90973 20.2842 6.21547 20.5905 6.5918 20.7822C7.01921 21 7.579 21 8.69694 21L16.3031 21C17.421 21 17.98 21 18.4074 20.7822C18.7837 20.5905 19.0905 20.2842 19.2822 19.9079C19.5 19.4805 19.5 18.9215 19.5 17.8036V9.32568C19.5 9.20302 19.4999 9.09553 19.499 9M13.5004 3.00087C13.7858 3.00348 13.9657 3.01407 14.1382 3.05547C14.3423 3.10446 14.5379 3.18526 14.7168 3.29492C14.9186 3.41857 15.0918 3.59181 15.4375 3.9375L18.563 7.06298C18.9089 7.40889 19.0809 7.58136 19.2046 7.78319C19.3142 7.96214 19.3953 8.15726 19.4443 8.36133C19.4857 8.53379 19.4964 8.71454 19.499 9M13.5004 3.00087L13.5 5.80021C13.5 6.92031 13.5 7.48015 13.718 7.90797C13.9097 8.2843 14.2155 8.59048 14.5918 8.78223C15.0192 9 15.579 9 16.6969 9H19.499"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default React.memo(ProductionRequestIcon);
